import { TypographyProps } from '@mui/material';
import { BodyLargeStyled } from 'v3/shared/typography/BodyLarge/styles';

export const BodyLarge: React.FC<TypographyProps> = (props) => {
  return (
    <BodyLargeStyled variant="subtitle1" {...props}>
      {props.children}
    </BodyLargeStyled>
  );
};
